import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { AlertCircle, Crown, X } from 'lucide-react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { useNavigate } from 'react-router-dom';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const TrialEndingNotification = () => {
  const navigate = useNavigate();
  const [show, setShow] = useState(false);
  const [daysRemaining, setDaysRemaining] = useState(0);

  useEffect(() => {
    checkTrialStatus();
  }, []);

  const checkTrialStatus = async () => {
    try {
      const response = await axios.get(`${API}/subscription/usage-status`, {
        withCredentials: true,
        validateStatus: (status) => status === 200 || status === 401  // Aceitar 401 sem erro
      });
      
      // Se 401, usuário não está logado - ignorar silenciosamente
      if (response.status === 401) {
        return;
      }
      
      const { subscription } = response.data;

      if (subscription.status === 'trial' && subscription.trial_ends_at) {
        const trialEnd = new Date(subscription.trial_ends_at);
        const now = new Date();
        const diffDays = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));

        // Show notification if 2 days or less remaining
        if (diffDays <= 2 && diffDays > 0) {
          setDaysRemaining(diffDays);
          setShow(true);
        }
      }
    } catch (error) {
      // Ignorar erro silenciosamente (usuário não logado)
      // console.error('Error checking trial status:', error);
    }
  };

  if (!show) return null;

  return (
    <Card className="fixed bottom-4 right-4 z-50 p-4 bg-gradient-to-br from-orange-500 to-amber-600 text-white shadow-2xl max-w-sm border-2 border-orange-400 animate-in slide-in-from-bottom">
      <button
        onClick={() => setShow(false)}
        className="absolute top-2 right-2 text-white/80 hover:text-white"
      >
        <X className="w-4 h-4" />
      </button>
      
      <div className="flex items-start gap-3">
        <AlertCircle className="w-6 h-6 flex-shrink-0 mt-0.5" />
        <div>
          <h3 className="font-bold text-lg mb-1">
            ⏰ Trial Acabando em {daysRemaining} {daysRemaining === 1 ? 'dia' : 'dias'}!
          </h3>
          <p className="text-sm text-white/90 mb-3">
            Seu período de teste Premium está terminando. Continue aproveitando todos os benefícios!
          </p>
          <Button
            onClick={() => {
              setShow(false);
              navigate('/subscription');
            }}
            size="sm"
            className="bg-white text-orange-600 hover:bg-gray-100 font-semibold"
          >
            <Crown className="w-4 h-4 mr-2" />
            Assinar Premium
          </Button>
        </div>
      </div>
    </Card>
  );
};

export default TrialEndingNotification;
